import { StorefrontSearchView, StorefrontView } from '@zola/svc-marketplace-ts-types';

import { VendorSearchRequestType } from '~/pages/couples/explore/components/SearchResults/types/types';
import type { CouplesStorefrontDetails } from '~/types/storefrontDetails';
import ApiService from '~/util/apiService';

export const getStorefront = (slug: string) => {
  return ApiService.get<StorefrontView>(`/web-marketplace-api/v1/storefront/by-slug/${slug}`);
};

export const getStorefrontByUuid = (uuid: string) => {
  return ApiService.get<StorefrontView>(`/web-marketplace-api/v1/storefront/by-uuid/${uuid}`);
};

export const getStorefrontDetails = (slug: string) => {
  return ApiService.get<CouplesStorefrontDetails>(
    `/web-marketplace-api/v1/storefront/with-details/${slug}`
  );
};

export const fetchStorefrontSearchResults = (search: VendorSearchRequestType) => {
  return ApiService.post<StorefrontSearchView, VendorSearchRequestType>(
    '/web-marketplace-api/v4/storefront/search',
    search
  );
};
